<script>
	import { onMount } from 'svelte';
	
		import Items from './Items.svelte'
		import Map from './Map.svelte'
		import { getTitle, setTitle, sendAnalyticsStat, getEdit, setEdit, getInterestingMapMode} from './common.js'
		let items = []
		let selectedItemIndex = -1;
		let csv = ''
		let title = ''
		let textarea = null
		let edit = true
		let interestingMapMode = false
	
		onMount(() => {
			title = getTitle()
			edit = getEdit()
			interestingMapMode = getInterestingMapMode()
			updateEditMode(edit)
			sendAnalyticsStat()
		})
	
		$ : updateStoredTitle(title) 
		let updateStoredTitle = (newTitle) => {
			if (!newTitle) {
				return
			}
			setTitle(newTitle)
		}
	
		let updateEditMode = (newEdit) => {
			edit = newEdit
			setEdit(newEdit)
		}
	
		let scrollToBottomOfTextArea = () => {
			textarea.scrollTop = textarea.scrollHeight
		}
	
		let collectFeedback = () => {
			let feedback = prompt('(Provide email in text if you want a response)\n\nFeedback/Thoughts/Ideas/Suggestions/Criticism:\n\n\n')
			if (!feedback) {
				return
			}
			if (feedback.length === 0) {
				alert('Feedback must contain text.')
				return
			}
			fetch(
				'https://formservice-api.xantasoft.com/submitJson/01484d8a-3fea-41e7-b370-96add79aadb9',
				{ method: 'POST', body: JSON.stringify({ 'feedback': feedback }), mode: "no-cors"})
			.then(r => {
				if (r.status === 200) {
					alert('Feedback delivered, thank you!')
				} else {
					alert("Problem sending feedback, please try again!")
				}
				return
			})
		}
	
		function copyInterestingMapLink() {
			// Use the Clipboard API to copy the text to the clipboard
			navigator.clipboard.writeText(`https://interestingmaps.xantasoft.com/${encodeURIComponent(title)}.html`)
			.then(function() {
				// Success! Text was copied to the clipboard.
				alert('Share Link Copied To Clipboard');
			})
			.catch(function(err) {
				// Error handling in case copying to clipboard fails.
				alert('Failed to copy text to clipboard. Error: ' + err);
			});
		}
	</script>
	
	<style>
		:global(body) {
			margin: 0;
			padding: 0px;
		}
	
		#top-holder {
			width: 100%;
			display: flex;
			flex-direction: row;
			min-height: 100%;
		}
	
		#items-holder {
			flex: 1;
			border-right: 1px solid lightgray;
			border-bottom: 1px solid lightgray;
		}
	
		#map-holder {
			flex: 1;
		}
	
		#controls {
			position: fixed;
			top: 0;
			right: 0;
			z-index: 1000000000;
			padding: 10px;
			font-size: 12px;
			display: inline;
		}
	
		#controls button {
			color: white;
			background-color: black;
			border-radius: 30px;
			padding-left: 10px;
			padding-right: 10px;
			cursor: pointer;
		}
	
		#controls button:hover {
			background-color: rgb(87, 87, 87);
		}
	
		.control {
			font-size: 16px;
			background-color: rgba(0, 0, 0, 0.4);
			padding: 5px;
			color: white;
			border-radius: 10px;
		}
	
		#floating-title {
			position: fixed;
			top: 0;
			left: 0;
			z-index: 1000000000;
			font-size: 32px;
			font-weight: bold;
			padding: 5px;
			padding-left: 10px;
		}
	
		@media (max-width:800px) {
			#top-holder {
				flex-direction: column;
			}
	
			#controls {
				top: auto;
				bottom: 0;
				left: 0;
				right: auto;
			}
		}
	</style>
	
	{#if interestingMapMode || !edit}
		<div id="floating-title">{title}</div>
	{/if}
	
	<div id="controls">
		{#if !interestingMapMode}
			<a class="control" href="#" on:click={() => updateEditMode(!edit)}>{edit ? "view only" : "edit"}</a>
			<a class="control" href="/" target="_blank">new map</a>
			<a class="control" href="#" on:click={collectFeedback}>feedback</a>
			<a class="control" href="https://xantasoft.com" target="_blank">info</a>
		{:else}
			<a class="control" href="#" on:click={copyInterestingMapLink}>Share</a>
			<a class="control" href="https://interestingmaps.xantasoft.com" target="_blank">More Interesting Maps...</a>
		{/if}
		
	</div>
	
	<div id="top-holder">
		<Items bind:csv={csv} bind:items={items} bind:selectedItemIndex={selectedItemIndex} bind:title={title} bind:textarea={textarea} edit={edit && !interestingMapMode}></Items>
		<Map bind:csv={csv} bind:items={items} bind:selectedItemIndex={selectedItemIndex} scrollToBottomOfTextArea={scrollToBottomOfTextArea} edit={edit && !interestingMapMode}></Map>
	</div>
	
	